export default __webpack_public_path__ + "static/media/AnimalsBlue_08.b96b98be.png";